import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {AnalyticsService} from './services/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'frontend';

  constructor(analytics: AnalyticsService) {
    analytics.initialize();
  }
}
